import 'jquery';
import { slickDisponiveis } from '../brico/slick';

export default {
  init() {
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      method: 'POST',
      data: {
        action: 'get_produtos_relacionados',
        product_id: window.post_id,
      },
      success: function (data) {
        $('.container-relacionados').html(data);
        $('.slick-disponiveis-1').slick(slickDisponiveis);
      },
    });

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      method: 'POST',
      data: {
        action: 'get_outros_viram',
        product_id: window.post_id,
      },
      success: function (data) {
        $('.container-outros-viram').html(data);
        $('.slick-disponiveis-2').slick(slickDisponiveis);
      },
    });
  },
  finalize() {},
};



// WEBPACK FOOTER //
// ./scripts/routes/single-product.js